module.exports = __webpack_public_path__ + "img/peerpal-gravyty-logo.77220c7d.svg";